import type { Editor } from '@tiptap/core';

/**
 * An onOpenChange handler for toolbar menus and popovers. Closing one would
 * otherwise leave focus on its trigger instead of the editor. The editor
 * can be gone by the time the timer fires, if the page moved on.
 */
export function refocusOnClose(editor: Editor) {
   return (open: boolean) => {
      if (!open) {
         setTimeout(() => {
            if (!editor.isDestroyed) {
               editor.commands.focus();
            }
         }, 50);
      }
   };
}
